<template>
  <div class="made-by-component text--center pb-3">
    <span class="bold">
        {{ new Date().getFullYear() }}
        <a href="https://www.prefeitura.sp.gov.br/cidade/secretarias/inovacao/" target="_blank" class="link" >Secretaria Municipal de Inovação e Tecnologia</a> da 
        <a href="http://www.capital.sp.gov.br/" target="_blank" class="link" >Prefeitura de São Paulo</a>.
    </span>
  </div>
</template>

<script>
export default {
  name: 'made-by',
}
</script>

<style lang="scss">
.made-by-component {
  width: 100%;
  position: absolute;
  bottom: 0;
  color: $white;
}
</style>
